/**
 * SongHistory — the "recently played" list from AzuraCast's song_history.
 *
 * New in v3.0: v2 only surfaced the current track, which is a shame when the
 * feed already carries what just went by. Renders nothing until the backend has
 * history to show, so an Icecast-only response stays visually identical to v2.
 */

import React from 'react';
import { motion } from 'framer-motion';

export default function SongHistory({ history }) {
  const items = Array.isArray(history) ? history.slice(0, 4) : [];
  if (!items.length) return null;

  return (
    <motion.div
      className="mb-8 w-full max-w-md"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.7 }}
    >
      <p className="dmr-label mb-3 text-center">Recently</p>
      <ul className="flex flex-col gap-1" data-testid="song-history">
        {items.map((song, index) => (
          <li
            key={`${song.artist}-${song.title}-${index}`}
            className="flex items-center justify-between gap-3 border-b border-[#1a1a1a] pb-1 text-xs last:border-0"
          >
            <span className="truncate text-[#e5e5e5]/70">
              {song.artist}
              {song.artist && song.title ? ' — ' : ''}
              {song.title}
            </span>
            <span className="dmr-hint shrink-0 tabular-nums">
              {String(index + 1).padStart(2, '0')}
            </span>
          </li>
        ))}
      </ul>
    </motion.div>
  );
}
